import api from '../api/instance';

import { DataGenerator } from '@testsigmainc/models';
import { Page } from '@testsigmainc/models';
import { PrivateURLConstants } from '@constants/private-url.constant';

const nameSpace = PrivateURLConstants.DATA_GENERATORS;

const findAll = (query) => {
  return api
    .get(nameSpace, { query })
    .then((res) => new Page<DataGenerator>().deserialize(res, DataGenerator))
    .catch((e) => Promise.reject(e));
};
const findAllByFileId = (fileId: number) => {
  return api
    .get(`${nameSpace}/file/${fileId}`)
    .then((res: []) =>
      res.map((data) => {
        const _data = new DataGenerator().deserialize(data);
        return _data;
      }),
    )
    .catch((e) => Promise.reject(e));
};

const findAllFunctionNames = (filterQuery?) => {
  return api
    .get(nameSpace + '/functions/DefaultTestData')
    .then((res) => res)
    .catch((e) => Promise.reject(e));
};
const show = (functionId: number) => {
  return api
    .get(nameSpace + '/' + functionId)
    .then((res) => new DataGenerator().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const DataGeneratorService = {
  findAll,
  findAllByFileId: findAllByFileId,
  findAllFunctionNames: findAllFunctionNames,
  show,
};

export default DataGeneratorService;
